import { cloneRecords } from "../domain/state.js";
import { freezeProgression } from "./progression-state.js";
import { freezeCalendars, freezeMarkets, freezeTasks } from "./timed-state.js";
export function makeSnapshot(parts) {
    const allocations = Object.fromEntries(Object.entries(parts.allocations).map(([id, values]) => [id, Object.freeze(values)]));
    return Object.freeze({
        ...parts,
        resources: Object.freeze(parts.resources),
        purchaseCounts: Object.freeze(parts.purchaseCounts),
        allocations: Object.freeze(allocations),
        productionTotals: Object.freeze(parts.productionTotals),
        scopeGenerations: Object.freeze(parts.scopeGenerations),
        progression: freezeProgression(parts.progression),
        tasks: freezeTasks(parts.tasks),
        calendars: freezeCalendars(parts.calendars),
        markets: freezeMarkets(parts.markets),
        records: Object.freeze(cloneRecords(parts.records)),
        domainEventJournal: Object.freeze({
            ...parts.domainEventJournal,
            events: Object.freeze([...parts.domainEventJournal.events]),
        }),
    });
}
//# sourceMappingURL=snapshot.js.map